export const userProfile = {
  namespaced: true,
  state: {
    documentationSearch: null,
    overview: {
      options: null,
      search: null
    }
  }, mutations: {
    storeDocumentationSearch(state, search) {
      state.documentationSearch = search;
    },
    storeUsersOverviewSearch(state, search) {
      state.overview.search = search;
    },
    storeUsersOverviewOptions(state, options) {
      state.overview.options = options
    }
  }
}
